"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SIACMSContentItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PageLayout = _interopRequireDefault(require("../PageLayout/PageLayout"));
var _TextBox = _interopRequireDefault(require("../TextBox/TextBox"));
var _PagePicture = _interopRequireDefault(require("../PagePicture/PagePicture"));
var _List = _interopRequireDefault(require("../List/List"));
var _Section = _interopRequireDefault(require("../Section/Section"));
var _DownloadLinkBox = _interopRequireDefault(require("../DownloadLinkBox/DownloadLinkBox"));
var _PageAccordion = _interopRequireDefault(require("../PageAccordion/PageAccordion"));
var _PageAccordionGeneric = _interopRequireDefault(require("../PageAccordionGeneric/PageAccordionGeneric"));
var _OrganisationMember = _interopRequireDefault(require("../OrganisationMember/OrganisationMember"));
var _Timeline = _interopRequireDefault(require("../Timeline/Timeline"));
var _InFormItem = _interopRequireDefault(require("../InForm/InFormItem"));
var _InApp = _interopRequireDefault(require("../InApp/InApp"));
var _ArticleBoxArea = _interopRequireDefault(require("../ArticleBoxArea/ArticleBoxArea"));
var _GSemployeeRoleItem = _interopRequireDefault(require("../GSemployeeRole/GSemployeeRoleItem"));
var _Consultation = _interopRequireDefault(require("../Consultation/Consultation"));
var _Normen = _interopRequireDefault(require("../Normen/Normen"));
var _Vacancies = _interopRequireDefault(require("../Vacancies/Vacancies"));
var _Slider = _interopRequireDefault(require("../SIAHomepage/Slider/Slider"));
var _Agenda = _interopRequireDefault(require("../SIAHomepage/Agenda/Agenda"));
var _HotTopics = _interopRequireDefault(require("../SIAHomepage/HotTopics/HotTopics"));
var _ServicesLinks = _interopRequireDefault(require("../SIAHomepage/ServicesLinks/ServicesLinks"));
var _Divider = _interopRequireDefault(require("../Divider/Divider"));
var _BusinessLinks = _interopRequireDefault(require("../SIAHomepage/BusinessLinks/BusinessLinks"));
var _useBreakPoint = require("../../../common/useBreakPoint");
var _removeSuggestionTags = _interopRequireDefault(require("../../../common/removeSuggestionTags"));
var _TextBoxWithLinks = _interopRequireDefault(require("./TextBoxWithLinks/TextBoxWithLinks"));
var _Interview = _interopRequireDefault(require("./Interview/Interview"));
var _Citation = _interopRequireDefault(require("./Citation/Citation"));
var _InterviewMulti = _interopRequireDefault(require("./InterviewMulti/InterviewMulti"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SIACMSContentItem = _ref => {
  let {
    item,
    lang,
    history,
    ...rest
  } = _ref;
  if (item.paragraph_type === 'container') {
    return /*#__PURE__*/_react.default.createElement(_PageLayout.default, {
      variant: item.layout,
      bgColor: item.background_color?.name
    }, [0, 1, 2, 3].map(i => {
      if (!item.children || item.children?.length === 0) return /*#__PURE__*/_react.default.createElement("div", {
        key: i
      });
      const element = item.children['col_' + i];
      if (!element) return /*#__PURE__*/_react.default.createElement("div", {
        key: i
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: `col_${i}`,
        key: i
      }, element.map((subItem, index) => /*#__PURE__*/_react.default.createElement(SIACMSContentItem, _extends({
        key: index,
        item: subItem,
        lang: lang,
        history: history,
        layout: item.layout
      }, rest))));
    }));
  }
  if (item.paragraph_type === 'newsletter_block') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "sia-margin-03-bottom  sia-border-01-bottom"
    }, item?.block_content?.map(block => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: block.id,
        className: "sia-padding-02-inline"
      }, /*#__PURE__*/_react.default.createElement(SIACMSContentItem, _extends({
        item: block,
        lang: lang,
        history: history,
        layout: item.layout
      }, rest)));
    }));
  }
  if (item.paragraph_type === 'text_box_col') {
    return /*#__PURE__*/_react.default.createElement(_TextBox.default, {
      items: item.text_box_elements,
      lang: lang
    });
  }
  if (item.paragraph_type === 'divider') {
    return /*#__PURE__*/_react.default.createElement(_Divider.default, {
      type: item.divider_type
    });
  }
  if (item.paragraph_type === 'picture') {
    if (!item.picture) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    return /*#__PURE__*/_react.default.createElement(_PagePicture.default, {
      src: item.picture[0]?.original?.url,
      srcTablet: item.picture[0]?.tablet?.url,
      srcMobile: item.picture[0]?.mobile?.url,
      copyright: {
        title: item.picture[0]?.title,
        copyright: item.picture[0]?.copyright
      }
    });
  }
  if (item.paragraph_type === 'link_downloads_box') {
    return /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
      title: item.title,
      items: item?.link_downloads_box_element,
      lang: lang
    });
  }
  if (item.paragraph_type === 'page_section') {
    return /*#__PURE__*/_react.default.createElement(_Section.default, _extends({
      item: item,
      lang: lang,
      Item: SIACMSContentItem,
      history: history
    }, rest, {
      maxElements: 4
    }));
  }
  if (item.paragraph_type === 'list') {
    return /*#__PURE__*/_react.default.createElement(_List.default, {
      title: item.title || '',
      items: item.paragraph_multi?.map(el => {
        return {
          content: el
        };
      }),
      variant: item.list_type.name.toUpperCase(),
      lang: lang
    });
  }
  if (item.paragraph_type === 'accordion') {
    return /*#__PURE__*/_react.default.createElement(_PageAccordion.default, {
      item: item
    });
  }
  if (item.paragraph_type === 'accordion_generic') {
    return /*#__PURE__*/_react.default.createElement(_PageAccordionGeneric.default, _extends({
      item: item,
      Item: SIACMSContentItem,
      history: history,
      lang: lang
    }, rest));
  }
  if (item.paragraph_type === 'gs_employee_role') {
    return /*#__PURE__*/_react.default.createElement(_GSemployeeRoleItem.default, {
      item: item
    });
  }
  if (item.paragraph_type === 'organisation_member_function') {
    const name = item?.email?.split('@')[0]?.split('.');
    return /*#__PURE__*/_react.default.createElement(_OrganisationMember.default, {
      firstname: name?.length > 0 ? name[0]?.charAt(0)?.toUpperCase() + name[0]?.slice(1) : 'Firstname',
      lastname: name?.length > 1 ? name[1]?.charAt(0)?.toUpperCase() + name[1]?.slice(1) : 'Lastname',
      role: 'Role',
      academic_title: "Dr.",
      diploma_title: 'Diploma title',
      section_memberships: ['ZH'],
      sia_membership: "Membership",
      professional_group_membership: "Group",
      email: item.email || ''
    });
  }
  if (item.paragraph_type === 'timeline') {
    return /*#__PURE__*/_react.default.createElement(_Timeline.default, {
      item: item
    });
  }
  if (item.paragraph_type === 'inform') {
    return /*#__PURE__*/_react.default.createElement(_InFormItem.default, _extends({
      lang: lang,
      item: item,
      history: history
    }, rest));
  }
  if (item.paragraph_type === 'inapp' || item.paragraph_type === 'in_app') {
    return /*#__PURE__*/_react.default.createElement(_InApp.default, _extends({
      lang: lang,
      item: item,
      history: history
    }, rest));
  }
  if (item.paragraph_type === 'article_boxes_area') {
    return /*#__PURE__*/_react.default.createElement(_ArticleBoxArea.default, _extends({
      lang: lang,
      items: item.articles
    }, rest));
  }
  if (item.paragraph_type === 'themen_articles_boxes_area') {
    return item.articles?.length > 0 ? /*#__PURE__*/_react.default.createElement(_ArticleBoxArea.default, _extends({
      lang: lang,
      items: item.articles
    }, rest)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  if (item.paragraph_type === 'consultation') {
    return /*#__PURE__*/_react.default.createElement(_Consultation.default, _extends({
      lang: lang,
      items: item.consultations,
      history: history
    }, rest));
  }
  if (item.paragraph_type === 'normen') {
    return /*#__PURE__*/_react.default.createElement(_Normen.default, _extends({
      lang: lang,
      items: item.normen,
      normen_type: item.normen_type.name
    }, rest));
  }
  if (item.paragraph_type === 'vacancies') {
    return /*#__PURE__*/_react.default.createElement(_Vacancies.default, _extends({
      items: item.vacancies,
      lang: lang
    }, rest));
  }
  if (item.paragraph_type === 'homepage_slider') {
    const items = item.slide?.map(el => {
      if (el.paragraph_type === 'article_slide') {
        const article = el.article_slide_article[0];
        if (!article) return {};
        return {
          title: article?.title || '',
          lead: article?.article_lead[0],
          src: article.pictures_gallery?.length > 0 ? article.pictures_gallery[0][0]?.desktop.url : '',
          srcTablet: article.pictures_gallery?.length > 0 ? article.pictures_gallery[0][0]?.tablet.url : '',
          srcMobile: article.pictures_gallery?.length > 0 ? article.pictures_gallery[0][0]?.mobile.url : '',
          top: article.article_type[0]?.name || '',
          tag: article.main_tag[0]?.name || '',
          link: `/${lang}/cms/node/${article.id}`
        };
      }
      const section_element = el.section_element ? '#' + el.section_element : '';
      const link = el.custom_slide_link.original_url === el.custom_slide_link.url ? el.custom_slide_link.original_url : `/${lang}/cms/node${el.custom_slide_link.node ? '/' + el.custom_slide_link.node : el.custom_slide_link.original_url}${section_element}`;
      return {
        title: el.custom_slide_title || '',
        lead: el.custom_slide_lead,
        top: '',
        tag: '',
        src: el.custom_slide_image[0]?.desktop.url,
        srcTablet: el.custom_slide_image[0]?.tablet.url,
        srcMobile: el.custom_slide_image[0]?.mobile.url,
        link
      };
    });
    return /*#__PURE__*/_react.default.createElement(_Slider.default, {
      items: items,
      lang: lang
    });
  }
  if (item.paragraph_type === 'homepage_articles') {
    return /*#__PURE__*/_react.default.createElement(_ArticleBoxArea.default, _extends({
      lang: lang,
      items: item.articles
    }, rest, {
      allEquals: rest.layout === 'layout_50_50'
    }));
  }
  if (item.paragraph_type === 'homepage_events') {
    return /*#__PURE__*/_react.default.createElement(_Agenda.default, _extends({
      item: item,
      title_background_color: item.title_background_color?.name,
      lang: lang,
      getAgenda: rest.getAgenda
    }, rest));
  }
  if (item.paragraph_type === 'homepage_hottopics') {
    return /*#__PURE__*/_react.default.createElement(_HotTopics.default, _extends({
      items: item.hottopic,
      title_background_color: item.title_background_color?.name,
      lang: lang
    }, rest));
  }
  if (item.paragraph_type === 'homepage_serviceslinks') {
    return /*#__PURE__*/_react.default.createElement(_ServicesLinks.default, _extends({
      items: item.serviceslinks,
      lang: lang
    }, rest));
  }
  if (item.paragraph_type === 'homepage_businesslinks') {
    return /*#__PURE__*/_react.default.createElement(_BusinessLinks.default, _extends({
      items: item.businesslinks,
      lang: lang
    }, rest));
  }
  if (item.paragraph_type === 'description_title') {
    return item.description_title.map((subItem, index) => /*#__PURE__*/_react.default.createElement("div", {
      className: "title sia-text-07",
      key: index
    }, subItem.name));
  }
  if (item.paragraph_type === 'text_box_title') {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "sia-text-04"
    }, (0, _removeSuggestionTags.default)(item.text_box_title));
  }
  if (item.paragraph_type === 'text_box_paragraph') {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "sia-padding-02-bottom sia-text-10"
    }, (0, _removeSuggestionTags.default)(item.paragraph));
  }
  if (item.paragraph_type === 'text_box_col_withlinks') {
    return /*#__PURE__*/_react.default.createElement(_TextBoxWithLinks.default, {
      items: item.text_box_elements,
      lang: lang
    });
  }
  if (item.paragraph_type === 'interview') {
    return /*#__PURE__*/_react.default.createElement(_Interview.default, {
      item: item,
      lang: lang
    });
  }
  if (item.paragraph_type === 'interview_multi') {
    return /*#__PURE__*/_react.default.createElement(_InterviewMulti.default, {
      item: item,
      lang: lang
    });
  }
  if (item.paragraph_type === 'citation') {
    return /*#__PURE__*/_react.default.createElement(_Citation.default, _extends({}, item, {
      lang: lang
    }));
  }
  if (item.paragraph_type) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "sia-padding-02-bottom"
    }, "TO DO:", item.paragraph_type);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
exports.SIACMSContentItem = SIACMSContentItem;
const orderChildrenByWeight = children => {
  let items = [];
  items = [...(children.col_0 ? Object.values(children.col_0) : []), ...(children.col_1 ? Object.values(children.col_1) : []), ...(children.col_2 ? Object.values(children.col_2) : []), ...(children.col_3 ? Object.values(children.col_3) : [])];
  return items.sort((el, el2) => {
    return (el.mobile_weight || 0) - (el2.mobile_weight || 0);
  });
};
const formatMobileItems = items => {
  let resultItems = [];
  const mapItems = Object.entries(items);
  for (let index = 0; index < mapItems.length; index++) {
    const item = mapItems[index][1];
    if (item.paragraph_type === 'container' && item.children) {
      const children = orderChildrenByWeight(item.children);
      const newItem = {
        ...item,
        children: {
          col_0: children
        }
      };
      resultItems.push(newItem);
    } else {
      resultItems.push(item);
    }
  }
  return resultItems;
};
const SIACMSContent = _ref2 => {
  let {
    items,
    lang,
    history,
    translate,
    inFormMethods,
    captchaKey,
    isHomePage = false,
    getAgenda,
    getParagraph,
    organisationData
  } = _ref2;
  const mobileItems = _react.default.useMemo(() => isHomePage ? formatMobileItems(items) : Object.values(items), [items]);
  const {
    isMobile
  } = (0, _useBreakPoint.useBreakPoint)();
  const pageItems = isMobile ? mobileItems : Object.values(items);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, pageItems.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(SIACMSContentItem, {
      key: index,
      item: item,
      lang: lang,
      history: history,
      translate: translate,
      captchaKey: captchaKey,
      inFormMethods: inFormMethods,
      getAgenda: getAgenda,
      getParagraph: getParagraph,
      organisationData: organisationData
    });
  }));
};
SIACMSContent.propTypes = {
  items: _propTypes.default.oneOfType([_propTypes.default.object.isRequired, _propTypes.default.array.isRequired]),
  lang: _propTypes.default.string.isRequired,
  translate: _propTypes.default.func.isRequired,
  inFormMethods: _propTypes.default.object,
  captchaKey: _propTypes.default.string,
  isHomePage: _propTypes.default.bool,
  getAgenda: _propTypes.default.func,
  getParagraph: _propTypes.default.func
};
var _default = exports.default = SIACMSContent;